import React from 'react';
import dayjs from 'dayjs';
import DatePicker from '../../../../../../components/Common/UI/DataPicker';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { IBatchDownloadState } from '../index';

interface IDocumentsDataPicker {
  from: string;
  to: string;
  handleDispatch: (payload: Partial<IBatchDownloadState>) => void;
}

function DocumentsDataPicker({ to, from, handleDispatch }: IDocumentsDataPicker) {
  return (
    <div className="flex lg:gap-[70px] gap-[20px] items-end flex-wrap">
      <div className="lg:mb-[15px] lg:w-auto w-full">Data Range</div>
      <div className="flex items-center lg:gap-[70px] gap-[20px] flex-wrap xs:w-auto w-full">
        <div className="sm:w-[250px] xs:w-[300px] w-full">
          <div className="text-addition1 uppercase text-[12px] mb-[13px]">From Date</div>
          <DatePicker
            date={dayjs(from).toDate()}
            className="font-normal border-addition1-10 bg-white w-full justify-between"
            icon={<Icons.Calendar2 className="[&_path]:fill-addition9" />}
            onSelect={(date?: Date) => {
              handleDispatch({ from: date?.toString() });
            }}
          />
        </div>
        <div className="sm:w-[250px] xs:w-[300px] w-full">
          <div className="text-addition1 uppercase text-[12px] mb-[13px]">To Date</div>
          <DatePicker
            icon={<Icons.Calendar2 className="[&_path]:fill-addition9" />}
            className="font-normal border-addition1-10 bg-white w-full justify-between"
            date={dayjs(to).toDate()}
            onSelect={(date?: Date) => {
              handleDispatch({ to: date?.toString() });
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default DocumentsDataPicker;
